import useMerchantPortalAxios from "../../utils/axios";

export default function useNewPhoneNumberAPI() {
  const client = useMerchantPortalAxios();

  async function validateNumberBack(phone, type, typeId = 2) {
    return client.get(
      `/v1/PhoneNumber/validate?SessionID=${sessionStorage.getItem("SessionID")}&Type=${type}&MobileNo=${phone}&AccountTypeId=${typeId}`,
    );
  }

  return {
    validateNumberBack,
  };
}
